module.exports = __webpack_public_path__ + "img/slack.761bc52c.jpg";